import { AuthClient, PatientPrescription, PatientPrescriptionsClient } from '../../../../generated';
import { httpRequest } from '../../../../utils';

const patientPrescriptionsPost = async (patientPrescription: PatientPrescription) => {
  const prescriptionsClient = new PatientPrescriptionsClient(new AuthClient());

  const prescriptionID = await httpRequest(() =>
    prescriptionsClient.patientPrescriptionsPost(patientPrescription),
  );

  return prescriptionID;
};

export { patientPrescriptionsPost };
